import type { ReactElement } from 'react';
import {
  SENS_EVOLUTION_LABELS,
  TYPE_EVENEMENT_LABELS,
  type EvolutionRecente,
} from '@kn/shared';

function formaterDelta(valeur: string): string {
  const nombre = Number(valeur);
  if (!Number.isFinite(nombre)) return valeur;
  return `${nombre > 0 ? '+' : ''}${nombre.toLocaleString('fr-FR', { maximumFractionDigits: 3 })}`;
}

/**
 * Ce que le dernier import a fait à l'écart — la vue du matin de Léonie.
 *
 * L'aggravation porte le poids visuel : c'est elle qu'on rate en lisant une
 * liste en diagonale, parce qu'un chiffre qui grossit ressemble à un chiffre.
 * La couleur ne porte jamais seule : le sens est écrit, et l'infobulle donne
 * les deux valeurs.
 */
export function BadgeEvolution({ evolution }: { evolution: EvolutionRecente | null }): ReactElement {
  if (evolution === null) return <span className="copack-vide">—</span>;

  const sens = SENS_EVOLUTION_LABELS[evolution.sens];
  const libelle =
    evolution.type === 'EVOLUTION' ? sens : TYPE_EVENEMENT_LABELS[evolution.type];

  return (
    <span
      className={`evolution evolution--${evolution.sens.toLowerCase()}`}
      title={
        evolution.journees.length > 0
          ? `Journées modifiées : ${evolution.journees.join(', ')}`
          : 'Recalcul sans import'
      }
    >
      {libelle}
      {evolution.type !== 'APPARITION' && <strong>{formaterDelta(evolution.delta)}</strong>}
    </span>
  );
}
